export default __webpack_public_path__ + "615f8ba1b440b17a4143812d837967d3.svg";